import moment from 'moment'
import {useApp} from '../hooks/StateHooks'

export const relative = (date: string, locale: string = '') => {
  if (!locale) {
    locale = useApp().locale
  }
  return moment.utc(date).locale(locale).fromNow()
}

export const relativeNonUtc = (date: string, locale: string = '') => {
  if (!locale) {
    locale = useApp().locale
  }
  return moment(date).locale(locale).fromNow()
}

export const date = (date: string, placeholder: string = '-') => {
  if (!date) {
    return placeholder
  }
  return moment.utc(date).format('DD.MM.YYYY')
}

export const dateTime = (date: string, placeholder: string = '-') => {
  if (!date) {
    return placeholder
  }
  return moment.utc(date).format('DD.MM.YYYY H:mm:ss')
}

export const year = (date: string, placeholder: string = '-') => {
  if (!date) {
    return placeholder
  }
  return moment.utc(date).format('YYYY')
}
export const monthYear = (date: string, placeholder: string = '-') => {
  if (!date) {
    return placeholder
  }
  return moment.utc(date).format('MM/YYYY')
}

